import React, { useState } from "react";
import { Container, Card, Row, Col, Form, Button } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import axios from "axios";
import DataTable from "react-data-table-component";
import * as XLSX from "xlsx";
import excelIcon from "../../assets/icons/excel.png";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { FaFilePdf } from "react-icons/fa";
import { Tooltip } from "@mui/material";
import AppDataGrid from '../../components/common/AppDataGrid';

const DailyAttendanceReport = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [attendanceData, setAttendanceData] = useState([]);
  const [attendanceDate, setAttendanceDate] = useState("");
  const userData = sessionStorage.getItem("user");
  const userObj = userData ? JSON.parse(userData) : {};
  const baseUrl = process.env.REACT_APP_API_BASE_URL;

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!attendanceDate) {
      toast.error("Please select a date.");
      return;
    }

    try {
      const response = await axios.post(baseUrl + "/dailyattendance/", {
        action: "FILTER",
        attendance_date: attendanceDate,
        school_id: userObj?.school_id || 0,
        academic_year_id: userObj?.academic_year_id || 0,
      });

      if (response.data && Array.isArray(response.data)) {
        setAttendanceData(response.data);
      } else {
        setAttendanceData([]);
      }
    } catch (error) {
      console.error("Error fetching attendance data:", error);
    } finally {
    }
  };
  const searchableColumns = [
    "class_name",
    "section_name",
    "total_present",
    "total_absent",
    "present_percentage",
    "absent_percentage",
  ];

const columns = [
  {
    field: 'class_name',
    headerName: 'Class',
    flex: 1,
    headerAlign: 'center',
    align: 'center',
    renderCell: (params) => (
      <Tooltip title={params.value || ''}>
        <span>{params.value || ''}</span>
      </Tooltip>
    ),
    sortable: true,
  },
  {
    field: 'section_name',
    headerName: 'Section',
    flex: 1,
    headerAlign: 'center',
    align: 'center',
    renderCell: (params) => (
      <Tooltip title={params.value || ''}>
        <span>{params.value || ''}</span>
      </Tooltip>
    ),
    sortable: true,
  },
  {
    field: 'total_present',
    headerName: 'Total Present',
    flex: 1,
    headerAlign: 'center',
    align: 'center',
    renderCell: (params) => (
      <Tooltip title={`${params.value ?? ''}`}>
        <span>{params.value ?? ''}</span>
      </Tooltip>
    ),
    sortable: true,
  },
  {
    field: 'total_absent',
    headerName: 'Total Absent',
    flex: 1,
    headerAlign: 'center',
    align: 'center',
    renderCell: (params) => (
      <Tooltip title={`${params.value ?? ''}`}>
        <span>{params.value ?? ''}</span>
      </Tooltip>
    ),
    sortable: true,
  },
  {
    field: 'present_percentage',
    headerName: 'Present %',
    flex: 1,
    headerAlign: 'center',
    align: 'center',
    renderCell: (params) => (
      <Tooltip title={`${params.value ?? ''}`}>
        <span>{params.value ?? ''}</span>
      </Tooltip>
    ),
    sortable: true,
  },
  {
    field: 'absent_percentage',
    headerName: 'Absent %',
    flex: 1,
    headerAlign: 'center',
    align: 'center',
    renderCell: (params) => (
      <Tooltip title={`${params.value ?? ''}`}>
        <span>{params.value ?? ''}</span>
      </Tooltip>
    ),
    sortable: true,
  },
];


  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const filteredRecords = (attendanceData || []).filter((student) => {
    return searchableColumns.some(
      (column) =>
        student[column] &&
        String(student[column])
          .toLowerCase()
          .includes(searchQuery.toLowerCase())
    );
  });

  const transformDataForExcel = (data) => {
    return data.map(({ total_students, ...item }) => {
      const transformed = {};
      for (let key in item) {
        const formattedKey = key.replace(/_/g, " ").replace(/\b\w/g, (l) => l.toUpperCase());
        transformed[formattedKey] = item[key];
      }
      return transformed;
    });
  };

  const exportToExcel = () => {
    if (attendanceData.length === 0) {
      toast.error("No data available to export.");
      return;
    }

    const transformedData = transformDataForExcel(attendanceData);
    const worksheet = XLSX.utils.json_to_sheet(transformedData);
    worksheet["!cols"] = Object.keys(transformedData[0]).map((key) => ({ wch: key.length + 10 }));

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Attendance Report");
    XLSX.writeFile(workbook, "AttendanceReport.xlsx");
  };

  const exportToPDF = () => {
    if (filteredRecords.length === 0) {
      toast.error("No data available to export.");
      return;
    }

    const doc = new jsPDF();
    doc.text("Daily Attendance Report", 14, 10);

    const tableColumn = [
      "Class",
      "Section",
      "Total Present",
      "Total Absent",
      "Present %",
      "Absent %",
    ];
    const tableRows = [];

    filteredRecords.forEach((row) => {
      tableRows.push([
        row.class_name || "",
        row.section_name || "",
        row.total_present || "",
        row.total_absent || "",
        row.present_percentage || "",
        row.absent_percentage || "",
      ]);
    });

    autoTable(doc, {
      head: [tableColumn],
      body: tableRows,
      startY: 20,
    });

    doc.save(`daily_attendance_report_${new Date().toISOString()}.pdf`);
  };

  return (
   
     
     
    
        
        <div className="pageBody">
           <ToastContainer />
          <Container fluid>
            <Card>
              <Card.Body>
                <form onSubmit={handleSubmit}>
                  <Row>
                    <Col xs={12}>
                      <h6 className="commonSectionTitle">
                        Daily Attendance Report
                      </h6>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={12} md={6} lg={3} xxl={3}>
                      <div className="commonInput">
                        <Form.Group>
                          <Form.Label>Attendance Date</Form.Label>
                          <Form.Control
                            type="date"
                            id="date_picker"
                            value={attendanceDate}
                            onChange={(e) => setAttendanceDate(e.target.value)}
                            required
                          />
                        </Form.Group>
                      </div>
                    </Col>
                    <Col>
                      <div className="d-flex justify-content-end gap-3 mt-4">
                        <Button
                          type="button"
                          variant="primary"
                          className="btn-info clearBtn"
                          onClick={() => {
                            setAttendanceDate("");
                            setAttendanceData([]);
                          }}
                        >
                          Reset
                        </Button>
                        <Button
                          type="submit"
                          variant="primary"
                          className="btn-success primaryBtn"
                        >
                          Search
                        </Button>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                  </Row>
                </form>
              </Card.Body>
            </Card>
            <div className="d-flex justify-content-between align-items-center mt-3">
              <input
                type="text"
                placeholder="Search..."
                value={searchQuery}
                className="form-control form-control-sm w-25"
                onChange={handleSearchChange}
              />
              <div>
                <Button
                  className="btnMain"
                  variant="success"
                  onClick={exportToExcel}
                  style={{ marginRight: "10px" }}
                >
                  <img
                    src={excelIcon}
                    alt="Download Excel"
                    style={{ width: "20px", marginRight: "5px" }}
                  />

                </Button>
                <Button
                  className="btnMain"
                  variant="danger"
                  onClick={exportToPDF}
                >
                  <FaFilePdf style={{ marginRight: "5px" }} />
                </Button>
              </div>
            </div>
            <div className="commonTable height100 mt-2">
              <div className="tableBody" style={{ overflowX: 'auto', maxHeight: '400px' }}>
                <AppDataGrid
                            rows={filteredRecords.length ? filteredRecords : []}
                            columns={columns}
                            getRowId={(row) => row.student_id || `${row.class_name}_${row.section_name}`} 
                            pageSizeOptions={[10, 20, 50]}      // Dropdown options
                            showToolbar={false}
                            pagination
                            density="compact"
                            maxHeight={400}
                        />
              </div>
            </div>
          </Container>
        </div>
     
  );
};

export default DailyAttendanceReport;
